import _ from 'lodash';
import { computed } from '@vue/composition-api';

import { ITrigger } from '@/types';
import { useSessions } from '@/modules/sessions-store';
import { useContacts } from '@/modules/contacts-store';
import { UIEventBus, OPEN_INIT_CONVERSATION_POPUP } from '@/common/ui-event-bus';

export const useContactInfo = () => {
  const { conversationTriggers } = useSessions();
  const { activeContact } = useContacts();

  const canStartConversation = computed(() => !_.isEmpty(conversationTriggers.value));

  const onStartConversation = (options: {
    triggers?: ITrigger[];
    identifier?: number;
  } = {}) => {
    UIEventBus.$emit(OPEN_INIT_CONVERSATION_POPUP, {
      contactId: activeContact.value!.contactId,
      triggers: options.triggers,
      toIdentifier: options.identifier,
    });
  };

  return { canStartConversation, onStartConversation };
};
